<template>
    <div class="edit-hub-details">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <router-link :to="'/hubListings'" class="text-primary">
                        <b-icon icon="chevron-left"></b-icon>
                        Hub Listings
                    </router-link>
                </b-col>
                <b-col cols="6" class="text-right">
                    <b-button v-show="backButton" class="btn-header" variant="primary" icon @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <el-tabs type="card">
                <!-- <el-tab-pane label="Tab 1"> -->
                    <edit-hub-details-form></edit-hub-details-form>
                    <new-sale-team></new-sale-team>
                <!-- </el-tab-pane> -->
                <!-- <el-tab-pane label="Tab 2">UNDER DEVELOPMENT</el-tab-pane>
                <el-tab-pane label="Tab 3">UNDER DEVELOPMENT</el-tab-pane>
                <el-tab-pane label="Tab 4">UNDER DEVELOPMENT</el-tab-pane> -->
            </el-tabs>
        </b-container>
    </div>
</template>
<script>
    import { Tabs, TabPane, Link } from 'element-ui'
    import EditHubDetailsForm from '@/views/Hub/HubDetails/EditForm'
    import NewSaleTeam from '@/views/Hub/HubDetails/NewSaleTeam'
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'

    export default {
        components: {
            EditHubDetailsForm,
            NewSaleTeam,
            RouteBreadCrumb,
            [Link.name]: Link,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
        },
        data() {
            return {
                backButton: true,
            };
        },
        created() {
            if(this.$route.params.token)
            {
                this.backButton = true;
            }
        },
        methods: {
            close() {
                if(this.$route.params.token)
                {
                    // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                    window.history.back();
                    window.close();
                }
                else
                {
                    this.$router.back();
                }
            }
        }
    }
</script>